import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { FiSend } from "react-icons/fi";
import "./styles.css";
import Section from "./Section";
import Wishlist from "./Wishlist.js";
import RightSideCard from "./RightSideCard.js";
import {
  getAllBookmark,
  BookmarkDelete,
} from "../../../../api/BookMarks/BookmarkApi.js";
import { getStockById } from "../../../../api/stock/getStockById.js";
import Pagination from "./Pagination";
import { getOrdersByBuyerId } from "../../../../api/order/orderApi";
import { AuthContext } from "../../../../pages/ExtraPages/AuthProvider";

// NeumorphismButton Component
const NeumorphismButton = () => {
  const buttonStyle = {
    padding: "6px 16px",
    border: "none",
    borderRadius: "50px",
    backgroundColor: "#E6F0FA",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#003366",
    transition: "all 0.3s ease",
  };

  const hoverStyle = {
    backgroundColor: "#003366",
    color: "#E6F0FA",
  };

  const [isHovered, setHovered] = React.useState(false);

  return (
    <button
      style={isHovered ? { ...buttonStyle, ...hoverStyle } : buttonStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <FiSend />
      <span>Track</span>
    </button>
  );
};

const FishMarketBuyerDashboard = () => {
  const [filteredData, setFilteredData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true); // Add loading state
  const itemsPerPage = 6;
  const [orders, setOrders] = useState([]);
  const { user } = React.useContext(AuthContext); // Use AuthContext to get user
  const [userId, setUserId] = useState(null); // Dynamic userId

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  // Fetch bookmark data
  const fetchBookMarkData = async () => {
    setLoading(true);
    console.log("userId", userId);
    try {
      const response = await getAllBookmark(userId);

      if (response && Array.isArray(response.data)) {
        const data = response.data;

        // Fetch additional data for each itemId
        const detailedData = await Promise.all(
          data.map(async (item) => {
            console.log("items ids", item.itemId);

            try {
              const detailedResponse = await getStockById(item.itemId);
              console.log("detailedResponse:", detailedResponse);
              return { ...item, details: detailedResponse.data };
            } catch (error) {
              console.error(
                `Error fetching details for itemId ${item.itemId}:`,
                error
              );
              return { ...item, details: null };
            }
          })
        );

        setFilteredData(detailedData);
      } else {
        console.warn("No stock data found or data is not an array");
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching bookmark data:", error);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch order data
  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await getOrdersByBuyerId(userId);
      const data = response.data.data;
      console.log("Orders Response:", data);
      setOrders(data || []); // Store fetched orders, fallback to empty array
    } catch (error) {
      console.error("Error fetching orders data:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch bookmarks and orders when userId is available
  useEffect(() => {
    if (userId) {
      fetchBookMarkData();
      fetchOrders();
    }
  }, [userId]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  console.log("Paginated Data:", paginatedData);

  // Delete bookmark
  const deleteItems = async (deleteItem) => {
    try {
      const deleteResponse = await BookmarkDelete(deleteItem);
      console.log("Delete Response:", deleteResponse);
      await fetchBookMarkData();
    } catch (error) {
      alert("An error occurred while deleting the item or fetching data");
      console.error("Error:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <React.Fragment>
      <section className="section gaps bg-light" style={{ paddingTop: "80px" }}>
        <Container fluid>
          <Section link="Buyer Dashboard" />
          {loading ? (
            <div
              className="loading-container"
              style={{ textAlign: "center", padding: "50px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading dashboard...</p>
            </div>
          ) : (
            <Row>
              <Col md={3} className="p-3">
                {paginatedData && paginatedData.length > 0 ? (
                  <div>
                    <Wishlist
                      BookMarkdata={paginatedData}
                      onDelete={deleteItems}
                    />
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                ) : (
                  <div className="no-result-container">
                    <i
                      className="mdi mdi-bookmark"
                      style={{ fontSize: "56px" }}
                    ></i>
                    <p>No bookmarks available to display.</p>
                    <a href="/stocks" className="btn btn-primary">
                      Back to Stock
                    </a>
                  </div>
                )}
              </Col>
              <Col md={9} className="p-3">
                <RightSideCard
                  orders={orders}
                  NeumorphismButton={NeumorphismButton}
                />
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default FishMarketBuyerDashboard;
